import React from 'react';

import { useModal } from '../Components/Modal/ModalContext';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeaderPanel from '../Components/HeaderPanel';

import LoadingLines from '../Components/LoadingLines';


const Testing = () => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();

    return (
        <>
        <div className='mainContainer'>
            <h1>Тестирование системы</h1>
            <HeaderPanel typePanel='Администратор' />
            <div style={{marginTop: '7px'}}></div>
            <a className='button' style={{width: 'fit-content'}} onClick={() => openModal('Тест заголовка', 'Тестирование постоянного модального окна')}>Открыть модально окно</a>
            <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Временное модальное окно warning', 'warning');}}>Открыть временное модально окно warning</a>
            <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Временное модальное окно error', 'error');}}>Открыть временное модально окно error</a>
            <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Временное модальное окно success', 'success');}}>Открыть временное модально окно success</a>
            <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Слово', 'success');}}>Открыть временное модальное окно success с малым содержимым</a>
            <LoadingLines />
        </div>
        </>
    )
}

export default Testing;